import type { RelatedSite } from '@/types';

/**
 * 연관 사이트 정보 상수
 * 
 * RISE사업단과 관련된 외부 사이트들의 정보를 정의합니다.
 * 각 사이트의 이름, 로고, URL을 포함하며, 홈페이지 하단의 연관사이트 섹션에서 사용됩니다.
 */
export const RELATED_SITES: RelatedSite[] = [
  { name: '충북RISE센터', logo: '/relatedsite-logo/cb-rise_logo.png', url: 'https://cbrise.or.kr' },
  { name: '충북대학교', logo: '/relatedsite-logo/cbnu_logo.png', url: 'https://www.cbnu.ac.kr' },
  { name: '충북대학교 산학협력단', logo: '/relatedsite-logo/cbnu-sanhak_logo.jpg', url: 'https://sanhak.cbnu.ac.kr' },
  { name: '충북PRIDE공유대학', logo: '/relatedsite-logo/cb-pride_logo.svg', url: 'https://apply.biopride.or.kr' },
  { name: 'RISE eZ시스템', logo: '/relatedsite-logo/rise-ez_logo.png', url: 'https://dev.cbnu.ac.kr/IACF' },
]; 